import type { FaireBrandEntity } from "../../entity_types/brand";

export const onboarding_offfaire_1: FaireBrandEntity = {
  token: "onboarding_offfaire_1",
  type: "brand",
  name: "Local Goods Co",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/e1b6ea6bf119ef548f6986675cad3959584a923e79ef33fe5975abed0d56a9f1.webp",
  minimumOrderDollars: 100,
  rating: 4.6,
  location: "US",
  tags: ["onboarding"],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
